export const villageDefaultValue = {
    id: '',
    name: '',
    district: undefined,
};
